import React from 'react';
import { color as palette } from "@/constants/palette";

interface PauseModalIconProps {
  /** 원 배경색 — 기본은 기존 파랑, 긴급 정지 모달은 red-2 전달 */
  color?: string;
}

function PauseModalIcon({ color = palette.primary }: PauseModalIconProps) {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='54'
      height='54'
      viewBox='0 0 54 54'
      fill='none'
    >
      <mask
        id='mask0_1954_9417'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='54'
        height='54'
      >
        <path d='M0 0H54V54H0V0Z' fill={palette.lineStrong} />
      </mask>
      <g mask='url(#mask0_1954_9417)'>
        <circle cx='27' cy='27' r='20.25' fill={color} />
        <path
          d='M31.2955 36C30.6205 36 30.0426 35.7482 29.5619 35.2446C29.0812 34.7411 28.8409 34.1357 28.8409 33.4286V20.5714C28.8409 19.8643 29.0812 19.2589 29.5619 18.7554C30.0426 18.2518 30.6205 18 31.2955 18C31.9705 18 32.5483 18.2518 33.029 18.7554C33.5097 19.2589 33.75 19.8643 33.75 20.5714V33.4286C33.75 34.1357 33.5097 34.7411 33.029 35.2446C32.5483 35.7482 31.9705 36 31.2955 36ZM22.7045 36C22.0295 36 21.4517 35.7482 20.971 35.2446C20.4903 34.7411 20.25 34.1357 20.25 33.4286V20.5714C20.25 19.8643 20.4903 19.2589 20.971 18.7554C21.4517 18.2518 22.0295 18 22.7045 18C23.3795 18 23.9574 18.2518 24.4381 18.7554C24.9188 19.2589 25.1591 19.8643 25.1591 20.5714V33.4286C25.1591 34.1357 24.9188 34.7411 24.4381 35.2446C23.9574 35.7482 23.3795 36 22.7045 36Z'
          fill='white'
        />
      </g>
    </svg>
  );
}

export default PauseModalIcon;
